import { useState } from "react";
import ToolCallPill from "./ToolCallPill";
import type { AnyToolCall } from "@containers/Hermes/types";

type ToolCallSummaryProps = {
  toolCalls: AnyToolCall[];
  isStreaming?: boolean;
};

const hasFailed = (toolCall: AnyToolCall) => typeof toolCall.error === "string" && toolCall.error !== "";

export default function ToolCallSummary({ toolCalls, isStreaming = false }: ToolCallSummaryProps) {
  const failedCount = toolCalls.filter(hasFailed).length;
  const [override, setOverride] = useState<boolean | null>(null);
  const expanded = override ?? failedCount > 0;

  if (isStreaming) {
    const current = toolCalls[toolCalls.length - 1];
    return (
      <div className="tw-flex tw-flex-col tw-gap-1 tw-mb-4 tw-max-w-2xl">
        <ToolCallPill toolCall={current} isStreaming />
        {toolCalls.length > 1 && <span className="tw-text-xs tw-text-gray-400 tw-pl-1">Step {toolCalls.length}</span>}
      </div>
    );
  }

  const label = `Completed ${toolCalls.length} ${toolCalls.length === 1 ? "step" : "steps"}`;

  return (
    <div className="tw-mb-4">
      <button type="button" onClick={() => setOverride(!expanded)} aria-expanded={expanded} className="tw-flex tw-items-center tw-gap-1 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-text-sm tw-leading-5 tw-font-medium tw-tracking-[-0.07px] tw-text-gray-500 hover:tw-text-gray-900">
        <span className={`material-symbols-outlined tw-text-[18px] ${failedCount > 0 ? "tw-text-error-500" : "tw-text-success-600"}`} aria-hidden="true">
          {failedCount > 0 ? "error" : "check_circle"}
        </span>
        <span>{failedCount > 0 ? `${label} (${failedCount} failed)` : label}</span>
        <span className="material-symbols-outlined tw-text-[18px]" aria-hidden="true">
          {expanded ? "expand_less" : "expand_more"}
        </span>
      </button>
      {expanded && (
        <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-2">
          {toolCalls.map((toolCall, i) => (
            <ToolCallPill key={`${toolCall.tool_name ?? toolCall.tool ?? "step"}-${i}`} toolCall={toolCall} />
          ))}
        </div>
      )}
    </div>
  );
}
